export default {
  dry: 'Dry',
  refrigerated: 'Refrigerated',
  frozen: 'Frozen',
};
